import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../LoadingSlice";
import {
  activateSweetAlert,
  deActivateSweetAlert,
} from "../SweetAlert";
import { toast } from "react-toastify";

interface ComplianceState {
  compliance: {
    load: boolean;
    data: [];
  };
}

export const complianceSlice = createSlice({
  name: "compliance",
  initialState: {
    compliance: {
      load: false,
      data: [],
    },
  } as ComplianceState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchcompliance.pending, (state: ComplianceState) => {
        state.compliance.load = true;
      })
      .addCase(fetchcompliance.fulfilled, (state: ComplianceState, action: any) => {
        state.compliance.data = action.payload;
        state.compliance.load = false;
      })
      .addCase(fetchcompliance.rejected, (state: ComplianceState) => {
        state.compliance.load = false;
      });
  },
});

export default complianceSlice.reducer;

export const fetchcompliance = createAsyncThunk(
  "compliance/fetchcompliance",
  async (param: { apiParam: { project_pin: any, layout_id: any, Code: any } }, thunkAPI) => {
    try {
      thunkAPI.dispatch(toggleLoading());
      const { data } = await DataServer.post("api/complianceData", {
        project_pin: param.apiParam.project_pin,
        layout_pin: param.apiParam.layout_id,
        code_group: param.apiParam.Code
      });
      thunkAPI.dispatch(toggleLoading());
      return data.data;
    } catch (error) {
      thunkAPI.dispatch(toggleLoading());
    }
  }
);

export const Savecompliance = createAsyncThunk(
    "compliance/Savecompliance",
    async (param: { apiParam: { project_pin: any, layout_id: any, compliance_data: any, NextTab: any } }, thunkAPI) => {
      try {
        thunkAPI.dispatch(toggleLoading());
        const { data } = await DataServer.post("api/addComplianceData", {
          compliance_data: JSON.stringify(param.apiParam.compliance_data)
        });
       
        toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

        const handleonConfirm = () => {
            param.apiParam.NextTab("tab_5");
        };
        return data.data;
	thunkAPI.dispatch(toggleLoading());

      } catch (error) {
        toast.error("Something went wrong!",{theme: "colored"});
        thunkAPI.dispatch(toggleLoading());
      }
    }
  );
